import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-grab-icon',
  templateUrl: './grab-icon.component.html',
  styleUrls: ['./grab-icon.component.scss']
})
export class GrabIconComponent implements OnInit {

  @Input() stroke: string = '#1A1A1C'

  constructor() { }

  ngOnInit() {
  }

}
